import { render } from "./UserTransactionsView.vue?vue&type=template&id=f51227e6&scoped=true"
import script from "./UserTransactionsView.vue?vue&type=script&lang=js"
export * from "./UserTransactionsView.vue?vue&type=script&lang=js"

import "./UserTransactionsView.vue?vue&type=style&index=0&id=f51227e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51227e6"]])

export default __exports__